
import {
  IContractTemplateTreeItemForm,
  IDistributionResponse,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { connectTemplateTreeItems } from '../templateQueryItemsConnector';

export const channelDistributionTemplateQueryToForm = (
  distribution: IDistributionResponse,
  lowestAvailableId?: string,
  disabledSelection = false,
  disabledRemove = false
): IContractTemplateTreeItemForm[] => {
  const [channelDistribution] = connectTemplateTreeItems(
    {
      channelDistribution: { ...distribution, position: 0 },
    },
    lowestAvailableId ?? '1'
  );

  const channelDistributionForm: IContractTemplateTreeItemForm = {
    ...channelDistribution,
    disabledSelection: disabledSelection,
    disabledRemove: disabledRemove,
  };

  return contractTemplateUtil.distribution.initialValues(
    TEMPLATE_TYPE.channelDistribution,
    [channelDistributionForm]
  );
};
